import { render, staticRenderFns } from "./assignTasks.vue?vue&type=template&id=4baabcc2&scoped=true&"
import script from "./assignTasks.vue?vue&type=script&lang=js&"
export * from "./assignTasks.vue?vue&type=script&lang=js&"
import style0 from "./assignTasks.vue?vue&type=style&index=0&id=4baabcc2&prod&lang=scss&scoped=true&"
import style1 from "./assignTasks.vue?vue&type=style&index=1&id=4baabcc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baabcc2",
  null
  
)

export default component.exports